import { makeAutoObservable } from 'mobx'
import { type IResponseCampaignsByIdQuietHoursMessage } from 'entities/Campaign'
import { Contact } from 'entities/Contacts/model/Contact'

export class CampaignQuietHoursMessage {
  contact
  constructor(public origin: IResponseCampaignsByIdQuietHoursMessage) {
    makeAutoObservable(this)
    this.contact = new Contact({
      ...origin.contact,
      tags: origin.contact.tags ?? [],
    } as ConstructorParameters<typeof Contact>[0])
  }

  get id() {
    return this.origin.id
  }

  get email() {
    return this.origin.contact.email ?? ''
  }

  get send_at() {
    return this.origin.send_at
  }

  get last_step_id() {
    return null
  }

  get steps_count() {
    return 0
  }

  get contact_has_replied() {
    return false
  }

  get team_id() {
    return this.origin.team_id
  }

  get isDisabled() {
    return this.contact.isDisabled
  }
}
